import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useAuth } from "context/authContext";

function PrivacyConsent() {
  const navigate = useNavigate();
  const { user, isAuthenticated, hasAcceptedPrivacyConsent, acceptPrivacyConsent, logout } = useAuth();
  const [checked, setChecked] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const init = async () => {
      const authenticated = await isAuthenticated();

      if (!authenticated) {
        navigate("/login", { replace: true });
        return;
      }

      if (hasAcceptedPrivacyConsent()) {
        if (user?.Role?.Description?.toLowerCase?.() === "admin") {
          navigate("/opcoes", { replace: true });
          return;
        }

        navigate("/ofertas", { replace: true });
      }
    };

    init();
  }, [isAuthenticated, hasAcceptedPrivacyConsent, navigate, user]);

  const handleAccept = async () => {
    if (!checked) {
      setError("Para continuar, você precisa aceitar a Política de Privacidade.");
      return;
    }

    const accepted = await acceptPrivacyConsent();

    if (!accepted) {
      setError("Não foi possível registrar seu consentimento. Tente novamente.");
      return;
    }

    if (user?.Role?.Description?.toLowerCase?.() === "admin") {
      navigate("/opcoes", { replace: true });
      return;
    }

    navigate("/ofertas", { replace: true });
  };

  const handleBackToLogin = async () => {
    setError("");
    await logout();
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h5" fontWeight="medium" color="white" mt={1}>
            Consentimento de Privacidade
          </MDTypography>
        </MDBox>

        <MDBox pt={3} pb={3} px={3}>
          <MDTypography variant="button" color="text" display="block" mb={2}>
            Para continuar no Portal de Fornecedores, precisamos do seu aceite da Política de
            Privacidade conforme a LGPD.
          </MDTypography>

          <MDTypography variant="caption" color="text" display="block" mb={2}>
            Você pode consultar a política completa no próprio portal antes de aceitar.
          </MDTypography>

          <MDBox mb={2}>
            <MDTypography
              component={Link}
              to="/politica-privacidade"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              Ler Política de Privacidade
            </MDTypography>
          </MDBox>

          <FormControlLabel
            control={<Checkbox checked={checked} onChange={(event) => setChecked(event.target.checked)} />}
            label="Li e aceito a Política de Privacidade de Fornecedores."
          />

          {error && (
            <MDBox mt={1}>
              <MDTypography variant="caption" color="error">
                {error}
              </MDTypography>
            </MDBox>
          )}

          <MDBox mt={3} display="flex" justifyContent="space-between" gap={2}>
            <MDButton color="secondary" variant="outlined" onClick={handleBackToLogin}>
              sair
            </MDButton>

            <MDButton color="info" variant="gradient" onClick={handleAccept}>
              aceitar e continuar
            </MDButton>
          </MDBox>

          <MDBox mt={2}>
            <MDTypography
              component="button"
              type="button"
              onClick={handleBackToLogin}
              variant="caption"
              color="info"
              fontWeight="medium"
              sx={{
                background: "none",
                border: 0,
                padding: 0,
                cursor: "pointer",
              }}
            >
              voltar para login
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default PrivacyConsent;